export default {
	TIME_TO_CLIMB: 'Time to Climb',
	MATCHING_PAIRS: 'Matching Pairs',
	DRAW_IT: 'DrawIt',
}
